(function () {
  if (window.__productMainLoaderInitialized) return;
  window.__productMainLoaderInitialized = true;

  var bootstrapScript = document.currentScript;
  if (!bootstrapScript) return;

  var swatchesSrc = bootstrapScript.dataset.productSwatchesSrc;
  var productMainSrc = bootstrapScript.dataset.productMainSrc;
  var runtimePromise = null;
  var deferredImageObserver = null;
  var deferredImageMutationObserver = null;

  function nextPaint() {
    return new Promise(function (resolve) {
      if (!window.requestAnimationFrame) {
        window.setTimeout(resolve, 0);
        return;
      }

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(resolve);
      });
    });
  }

  function findHeroImage() {
    var activeSlide = document.querySelector('[data-media-slider] .product-media-slide.is-active');
    return (
      (activeSlide && activeSlide.querySelector('img.media-image')) ||
      document.querySelector('[data-media-slider] img.media-image')
    );
  }

  function waitForHeroImage() {
    return new Promise(function (resolve) {
      var settled = false;
      var fallbackTimer = null;

      function finish() {
        if (settled) return;
        settled = true;
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        nextPaint().then(resolve);
      }

      function finishAfterDecode(image) {
        if (!image || typeof image.decode !== 'function') {
          finish();
          return;
        }

        image.decode().then(finish).catch(finish);
      }

      function inspectHero() {
        var heroImage = findHeroImage();
        fallbackTimer = window.setTimeout(finish, 5000);

        if (!heroImage || heroImage.complete) {
          finishAfterDecode(heroImage);
          return;
        }

        heroImage.addEventListener(
          'load',
          function () {
            finishAfterDecode(heroImage);
          },
          { once: true },
        );
        heroImage.addEventListener('error', finish, { once: true });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', inspectHero, { once: true });
      } else {
        inspectHero();
      }
    });
  }

  function loadScriptOnce(id, src, isReady) {
    if (!src || isReady()) return Promise.resolve();

    return new Promise(function (resolve, reject) {
      var existing = document.getElementById(id);

      if (existing) {
        if (isReady() || existing.dataset.loaded === 'true') {
          resolve();
          return;
        }

        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      script.fetchPriority = window.__productMainInteractionRequested ? 'high' : 'low';
      script.addEventListener(
        'load',
        function () {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true },
      );
      script.addEventListener(
        'error',
        function (error) {
          script.remove();
          reject(error);
        },
        { once: true },
      );
      document.head.appendChild(script);
    });
  }

  function loadRuntime() {
    if (runtimePromise) return runtimePromise;

    runtimePromise = Promise.all([
      loadScriptOnce('component-product-swatches-script', swatchesSrc, function () {
        return Boolean(window.ProductSwatches);
      }),
      loadScriptOnce('component-product-main-script', productMainSrc, function () {
        return Boolean(window.__productMainRuntimeLoaded);
      }),
    ]).catch(function (error) {
      runtimePromise = null;
      throw error;
    });

    return runtimePromise;
  }

  function waitForRuntimeReady() {
    if (window.__productMainEnhancementsReady) return Promise.resolve();

    return new Promise(function (resolve) {
      var fallbackTimer = window.setTimeout(resolve, 2500);

      window.addEventListener(
        'product-main:ready',
        function () {
          window.clearTimeout(fallbackTimer);
          resolve();
        },
        { once: true },
      );
    });
  }

  function hydrateDeferredImage(image) {
    if (!image || !image.dataset.deferredProductImageSrc) return;

    image.src = image.dataset.deferredProductImageSrc;
    image.removeAttribute('data-deferred-product-image-src');
    if (deferredImageObserver) deferredImageObserver.unobserve(image);
  }

  function observeDeferredImages(root) {
    var images = [];

    if (root instanceof Element && root.matches('[data-deferred-product-image-src]')) {
      images.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-deferred-product-image-src]').forEach(function (image) {
        images.push(image);
      });
    }

    images.forEach(function (image) {
      if (deferredImageObserver) {
        deferredImageObserver.observe(image);
      } else {
        hydrateDeferredImage(image);
      }
    });
  }

  function startDeferredImageLoading() {
    if ('IntersectionObserver' in window) {
      deferredImageObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) hydrateDeferredImage(entry.target);
          });
        },
        { rootMargin: '400px 0px' },
      );
    }

    observeDeferredImages(document);

    var productMain = document.querySelector('[data-product-main]');
    if (!productMain || deferredImageMutationObserver) return;

    deferredImageMutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) observeDeferredImages(node);
        });
      });
    });
    deferredImageMutationObserver.observe(productMain, { childList: true, subtree: true });
  }

  var replaySelector = [
    '[data-media-nav]',
    '[data-thumb-index]',
    '[data-view-specs]',
    '[data-swatch-nav]',
    '[data-swatch-layout-toggle]',
    '[data-more-style-swatches-toggle]',
  ].join(',');

  var warmSelector = replaySelector + ',[data-media-slider],.swatch-slider-track';

  function warmRuntime(event) {
    if (!event.target.closest || !event.target.closest(warmSelector)) return;
    window.__productMainInteractionRequested = true;
    window.dispatchEvent(new CustomEvent('product-main:interaction'));
    loadRuntime().catch(function (error) {
      console.error('Unable to load product enhancements.', error);
    });
  }

  function replayFirstInteraction(event) {
    if (!event.target.closest) return;
    var trigger = event.target.closest(replaySelector);
    if (!trigger || window.__productMainEnhancementsReady) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.__productMainInteractionRequested = true;
    window.dispatchEvent(new CustomEvent('product-main:interaction'));

    loadRuntime()
      .then(waitForRuntimeReady)
      .then(function () {
        trigger.click();
      })
      .catch(function (error) {
        console.error('Unable to load product enhancements.', error);
      });
  }

  document.addEventListener('pointerover', warmRuntime, true);
  document.addEventListener('focusin', warmRuntime, true);
  document.addEventListener('touchstart', warmRuntime, { capture: true, passive: true });
  document.addEventListener('click', replayFirstInteraction, true);

  waitForHeroImage().then(function () {
    window.__productMainHeroReady = true;
    startDeferredImageLoading();
    loadRuntime().catch(function (error) {
      console.error('Unable to load product enhancements.', error);
    });
  });
})();
